module.exports = __webpack_public_path__ + "img/news_head_3.07a23272.jpg";